<template lang="pug">
    div.cookie-notice.has-background-blue-lighter(v-if="!accepted")
        div.container.has-text-centered-mobile
            div.columns.is-vcentered
                div.column
                    p.is-inline {{ $t('cookie_notice.text_01') }}&nbsp;
                        // router-link.is-underline(:to="$t('cookie_notice.button_01.url')") {{ $t('cookie_notice.button_01.text') }}
                        // | &nbsp;{{ $t('cookie_notice.text_02') }}&nbsp;
                        router-link.is-underline(:to="$t('cookie_notice.button_02.url')") {{ $t('cookie_notice.button_02.text') }}
                        | .
                div.column.is-narrow
                    button.button.is-blue(@click="accepted = true") {{ $t('cookie_notice.button_03.text') }}

</template>

<script>
export default {
    name: 'cookie-notice',
    data () {
        return {
            accepted: false
        }
    }
}
</script>

<style scoped lang="stylus">

.cookie-notice
    position fixed
    width 100%
    bottom 0
    left 0
    padding 1.875rem 0

    .is-underline
        text-decoration underline

    p
        font-size 0.875rem

    .button
        font-size 0.675rem
        width auto
        padding 1rem 3.150rem

</style>
